import {findOne} from "@leap-spark/sparkies";
import {Loader} from "./lib/loader";


Loader.on({bodyClass: 'page-id-52'}, () => {
    autoFillForm();
});

function autoFillForm() {
    const param = getUrlParams();
    const field = findOne<HTMLInputElement>('#evf-204-field_FPq8NMRbuh-6');

    if (param.has('mailto')) {
        field.value = param.get('mailto');
    }
}

function getUrlParams(): Map<string, string> {
    const params = window.location.search;
    const paramArray: string[] = params.slice(1).split('&');

    const mappedParams = new Map();

    paramArray.forEach((param) => {
        const [key, value] = param.split('=');
        mappedParams.set(key, value);
    });

    return mappedParams;
}
